// Lazy load chart libraries only when needed
export const loadApexCharts = () => import('apexcharts')
export const loadChartJs = () => import('chart.js/auto')
export const loadD3 = () => import('d3')
export const loadD3Cloud = () => import('d3-cloud')
